export var CatalogMissingType;
(function (CatalogMissingType) {
    CatalogMissingType["MissingBrand"] = "missingBrand";
    CatalogMissingType["MissingCategory"] = "missingCategory";
    CatalogMissingType["MissingGtin"] = "missingGtin";
    CatalogMissingType["MissingUrl"] = "missingUrl";
    CatalogMissingType["MissingImageUrl"] = "missingImageUrl";
    CatalogMissingType["MissingCurrency"] = "missingCurrency";
    CatalogMissingType["MissingPrice"] = "missingPrice";
    CatalogMissingType["NonUniqueUrl"] = "nonUniqueUrl";
    CatalogMissingType["OffsiteMissingPrice"] = "offsiteMissingPrice";
})(CatalogMissingType || (CatalogMissingType = {}));
//# sourceMappingURL=catalog-missing-type.js.map